import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class EnablePublishLayerService {
  private enable: boolean;

  constructor() { 
    this.enable = false;
  }
  public setValue = (value: boolean) => {
    this.enable = value;
  }
  public getValue = () => {
    return this.enable;
  }
}
